import * as React from "react";
import * as ReactDOM from "react-dom";
import App from "../../signup/SignupApp";

window.addEventListener(
  "DOMContentLoaded",
  function() {
    ReactDOM.render(<App />, document.getElementById("signup-app"));
  },
  false
);
